import Vue from 'vue'
import Router from 'vue-router'
import Merchant from './modules/merchant/index.js'
import Integration from '@/pages/general/Integration.vue'
import BeDirectBookingGoogle from '@/pages/hotel/be/BeDirectBookingGoogle'
import CommunityIndex from '@/pages/community/'
import CommunityHome from '@/pages/community/Home'
import DevelopmentOnly from '@/pages/general/DevelopmentOnly'
import ClearDataLocal from '@/pages/general/ClearData'
import { applyResolvedTitle, BRAND_FALLBACK } from '../utils/titleService.js'
import { trackEvent } from '../utils/analytics.js'
import { isAuthQueryOnlyNavigation } from '../utils/authQuery.js'
import store from "../store";

const emptyView = {template: '<router-view></router-view>'}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/google-direct-booking',
      name: 'BeDirectBookingGoogle',
      component: BeDirectBookingGoogle,
      meta:{
        module_type: 'merchant-hotel-booking_engine',
        no_wrapper: true
      }
    },
    {
      path: '/integration',
      name: 'Integration',
      component: Integration
    },
    {
      path: '/community',
      component:CommunityIndex,
      children: [
        {
          path: '/:community_code/group',
          name: 'CommunityHome',
          component: CommunityHome,
          meta:{
            module_type: 'community',
            no_wrapper: true
          }
        },
      ]
    },
    {
      path: "/development",
      name: "DevelopmentOnly",
      component: DevelopmentOnly
    },
    {
      path: "/clear-data-guestaps-01",
      name: "ClearDataLocal",
      component: ClearDataLocal
    },
    ...Merchant
  ],
  mode: 'history'
})

function getDeepestRecord(to) {
  const m = to.matched || [];
  return m.length ? m[m.length - 1] : null;
}

router.beforeResolve(async (to, from, next) => {
  /* opening/closing the auth popup only toggles ?auth= — same page, same title */
  if (isAuthQueryOnlyNavigation(to, from)) return next();

  const deepest = getDeepestRecord(to);

  if (!deepest) {
    applyResolvedTitle({ router });
    return next();
  }

  const { meta } = deepest;
  const resolveInComponent = !!(meta && meta.resolveInComponent);  
  
  if(resolveInComponent) return next();
  
  const metaTitle = meta && meta.title;
  
  try {
    applyResolvedTitle({
      router,
      route: to,
      title: metaTitle ? metaTitle : null
    });
  } catch (e) {
    const fallback = store.getters.getMerchant.name || BRAND_FALLBACK;
    applyResolvedTitle({
      router,
      route: to,
      title: fallback,
      useTemplate: false
    });
  }
  
  next();
  
});

router.afterEach((to, from) => {

  if (isAuthQueryOnlyNavigation(to, from)) return;

  if (window.fbqReady) {
    Vue.prototype.$sendEventMetaConversionsAPI("PageView");
  } else {
    window.fbqQueue = []
    window.fbqQueue.push("PageView");
  }

  if (to.meta && to.meta.resolveInComponent) return;

  const pageTitle = document.title;
  if(pageTitle && pageTitle !== BRAND_FALLBACK){
    trackEvent('page_view', {to, from})
  }
  
})

// Strip merchant_code dari URL navigasi saat IS_MERCHANT_CODE_HIDE aktif
if (window.IS_MERCHANT_CODE_HIDE && window.MERCHANT_CODE) {
  const merchantPrefix = `/${window.MERCHANT_CODE}`
  const stripMerchantCode = (location) => {
    if (typeof location === 'string' && location.startsWith(merchantPrefix)) {
      return location.substring(merchantPrefix.length) || '/'
    }
    return location
  }

  const originalPush = router.push.bind(router)
  const originalReplace = router.replace.bind(router)

  router.push = function (location, onComplete, onAbort) {
    return originalPush(stripMerchantCode(location), onComplete, onAbort)
  }
  router.replace = function (location, onComplete, onAbort) {
    return originalReplace(stripMerchantCode(location), onComplete, onAbort)
  }
}

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js